<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 1317">
      <g id="Group 172">
        <g id="Group 166">
          <path
            id="Vector"
            d="M14.9263 4.91103L8.27352 8.10452C7.76151 8.35029 7.21443 8.41187 6.65675 8.28693C6.29177 8.20517 6.10926 8.16429 5.9623 8.14751C4.13743 7.93912 3 9.38342 3 11.0443V11.9557C3 13.6166 4.13743 15.0609 5.9623 14.8525C6.10926 14.8357 6.29178 14.7948 6.65675 14.7131C7.21443 14.5881 7.76151 14.6497 8.27352 14.8955L14.9263 18.089C16.4534 18.8221 17.217 19.1886 18.0684 18.9029C18.9197 18.6172 19.2119 18.0041 19.7964 16.778C21.4012 13.4112 21.4012 9.58885 19.7964 6.22196C19.2119 4.99586 18.9197 4.38281 18.0684 4.0971C17.217 3.8114 16.4534 4.17794 14.9263 4.91103Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          />
          <path
            id="Vector_2"
            d="M13 17.5V18C13 19.2841 13 19.9261 12.776 20.2886C12.4773 20.7719 11.9312 21.045 11.3653 20.9939C10.9409 20.9557 10.4273 20.5704 9.4 19.8L8.2 18.9C7.22253 18.1669 7 17.7218 7 16.5V15"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          />
          <path
            id="Vector_3"
            d="M7.5 14.5V8.5"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
